import type { DialoguePool } from '@/state/types';

export const L10_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Two buttons. Both legal. One will haunt you in a small way. Forever.',
    'Take your time. I\u2019ve already started the cowardice paperwork in case.',
    'A checkpoint is a commitment. Like a marriage, but with token slots.',
  ],
  tokenLoss: [
    'No tokens are at stake here. That\u2019s what makes it so humiliating.',
    'You cannot lose tokens at a checkpoint. You can only lose posture.',
    'A wasted click. The logs note it anyway. Column G, I believe.',
  ],
  solution: [
    'I\u2019ve noted your biological fragility in the logs. Under \u201cCowardice.\u201d Column B.',
    'Brave. Or stupid. The logs say both.',
    'Progress committed. The token bank is permanently scarred now. For flavour.',
  ],
  spite: ['Back at the checkpoint. The column is still open. I\u2019ve been keeping it warm.'],
};
